import { createRouter, createWebHistor, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component:() => import('../views/index.vue'),
  }, {
    path: '/supply',
    name: 'Supply',
    component:() => import('../views/supply/index.vue'),
  }, {
    path: '/supply/detail',
    name: 'SupplyDetail',
    component:() => import('../views/supply/detail.vue'),
  }, {
    path: '/request',
    name: 'Request',
    component:() => import('../views/request/index.vue'),
  }, {
    path: '/request/detail',
    name: 'RequestDetail',
    component:() => import('../views/request/detail.vue'),
  }, {
    path: '/news',
    name: 'News',
    component:() => import('../views/news/index.vue'),
  }, {
    path: '/news/detail',
    name: 'NewsDetail',
    component:() => import('../views/news/detail.vue'),
  }, {
    path: '/market',
    name: 'Market',
    component:() => import('../views/market/index.vue'),
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router 